import React, { useEffect } from 'react';
import {useNavigate} from "react-router-dom";

import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import heroImage3 from '../img/hero-img-3.jpg';
import heroImage2 from '../img/hero-img-2.jpg';
import heroImage1 from '../img/hero-img-1.jpg';
import heroImage4 from '../img/hero-img-4.jpg';
import heroImage5 from '../img/hero-img-5.jpg';
import about1 from '../img/main-about-1.png';
import about2 from '../img/main-about-2.png';
import about3 from '../img/main-about-3.png';
import solution1 from '../img/solution-1.png';
import solution2 from '../img/solution-2.png';
import solution3 from '../img/solution-3.png';
import laneBg from '../img/lane-bg.mp4';  
import bgTech from '../img/bg-tech.jpg';  
import tech1 from '../img/main-tech1.mp4';  
import tech2 from '../img/main-tech2.mp4';  
import tech3 from '../img/main-tech3.mp4';  
import tech4 from '../img/main-tech4.mp4';  


gsap.registerPlugin(ScrollTrigger);

function MainPage() {
    const navigate = useNavigate();
    useEffect(() => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: ".main-hero",
                scrub: true,
                pin: true,
                pinSpacing: true,
                start: "50% 50%",
                end: "+=500%"
            }
        })
        .to(".lane-2", { transform: 'translate(0%, -30%)', ease: "none" }, 0)
        .to(".lane-3", { transform: 'translate(0%, -10%)', ease: "none" }, 0)
        .to(".hero_img", { scale: 2.5, ease: "none" }, 1)
        .to(".lanebox", { borderRadius: 0, ease: "none" }, 1)
        .to(".hero_text", { scale: 2, ease: "none", transformOrigin: "center center" }, 1)
        .to(".hero_text", { bottom: "-100%", opacity: 0, ease: "none" }, 2);
    }, []);

    useEffect(() => {
        const elements = document.querySelectorAll('.list-item');
    
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('fade-up');
                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.5,
        });
    
        elements.forEach(element => observer.observe(element));
    
        return () => observer.disconnect();
    }, []);
  
  function goToSolution() { navigate('/solution'); };
  function goToTech() { navigate('/tech'); };
  
  return (
    <div>
      <section className="main-hero light">
        <div className="hero_text">
            <h3>클라우드 서비스 기반의<br/> <span className="gradient-text">크로스 플랫폼</span> 시작하기</h3>
            <p>최소한의 개발비용의 시스템<br/>스마트폰, 태블릿, 스마트워치, PC 등 다양한 플랫폼 지원<br/>빅데이터 활용하여 분석 및 예측할 수 있는 모니터링 시스템</p>
        </div>
        <div className="hero_img">
           <div className="imglane lane-1">
               <div className="lanebox">
                  <img src={heroImage3} alt="Hero Image3" />
               </div>
           </div>
           <div className="imglane lane-2">
               <div className="lanebox">
                  <img src={heroImage1} alt="Hero Image1" />
               </div>
               <div className="lanebox">
                  <img src={heroImage2} alt="Hero Image2" />
               </div>
           </div>
           <div className="imglane lane-3">
               <div className="lanebox">
                  <video className="video-background" poster={heroImage1} autoPlay loop muted playsInline>
                    <source src={laneBg} type="video/mp4" />
                  </video>
               </div>
           </div>
           <div className="imglane lane-2">
               <div className="lanebox">
                  <img src={heroImage4} alt="Hero Image4" />
               </div>
               <div className="lanebox">
                  <img src={heroImage5} alt="Hero Image5" />
               </div>
           </div>
           <div className="imglane lane-1">
               <div className="lanebox">
                  <img src={bgTech} alt="bgTech" />
               </div>
           </div>
        </div>
    </section>

    <section className="main-about">
       <div className="area">
           <div className="main-about-title">
                <h3>고객과 함께 성장하는 디지털 성장 파트너</h3>
                <p>위즈팩토리의 스마트팩토리 솔루션은 제조 공정 전반에 걸쳐 데이터를 수집하고 분석하여<br className="m-br"/>제조 기업이 보다 효율적으로 생산을 관리할 수 있도록 지원합니다.</p>
            </div>
            <div className="area-cont">
                <div className="main-about-list">
                    <div className="list-item">
                      <img src={about1} alt="about1" />
                        <h3>사물인터넷</h3>
                        <p>제조 장비, 센서, 기계 등이 네트워크를 통해 상호 연결되어 실시간 데이터를 수집</p>
                    </div>
                    <div className="list-item fade-up-delay-300">
                      <img src={about2} alt="about2" />
                        <h3>빅데이터 수집 및 분석</h3>
                        <p>수집된 대량의 데이터를 분석하여 의사결정 과정을 개선하고, 예측 유지보수, 수요 예측, 품질 관리 등을 수행</p>
                    </div>
                    <div className="list-item fade-up-delay-600">
                      <img src={about3} alt="about3" />
                        <h3>인공지능</h3>
                        <p>머신 러닝 알고리즘을 통한 지속적인 학습으로 예측 분석, 고장 예측, 자동 결함 감지 등에 활용</p>
                    </div>
                </div>
           </div>
        </div>        
    </section>
    <section className="main-solution light">
        <div className="area flex">
            <div className="area-tit">
               <div className="area-tit-text text-white">
                <h3>솔루션</h3>
                <p>IT 솔루션의 소프트웨어 시스템인 애플리케이션, 시스템과 연결하는 플랫폼, 하드웨어 중심 시스템인 장비 및 디바이스의 세 가지 제품으로 구성되어 있습니다.</p>
                <a onClick={goToSolution} className="btn-dark">VIEW MORE</a>
                </div>
            </div>
            <div className="area-cont">
                <div className="solution-img-wrap">
                    <div className="solution-img sol-1">
                      <img src={solution1} alt="solution1" />
                        <h3>애플리케이션</h3>
                        <p>플랫폼상에서 각종 제조 실행을 수행하는 애플리케이션.<br/>MES, ERP, PLM, SCM 등의 제품이 있습니다.</p>
                    </div>
                    <div className="solution-img sol-2">
                    <img src={solution2} alt="solution2" />
                        <h3>플랫폼</h3>
                        <p>표준화된 정보를 애플리케이션에 전달하는 미들웨어 수준의 기술들.<br/>빅데이터 분석, 사이버 물리 기술, 클라우드 기술 등의 제품이 있습니다</p>
                    </div>
                    <div className="solution-img sol-3">
                    <img src={solution3} alt="solution3" />
                        <h3>장비 및 디바이스</h3>
                        <p>장비에 내장되는 지능형 임베디드 소프트웨어 & 하드웨어 기술들.<br/>컨트롤러, 로봇, 센서, PC 등의 하드웨어 제품이 있습니다.</p>
                    </div>
                </div>
            </div>
        </div> 
    </section>
    <section className="main-tech">
      <div className="area flex">
          <div className="area-tit">
              <div className="area-tit-text">
                  <h3>연구개발</h3>
                  <p>사물 인터넷(IoT), 빅데이터 및 분석, 인공지능(AI) 및 머신 러닝, 사이버-물리 시스템(CPS), 클라우드 컴퓨팅 등 첨단 기술을 통합하여 제조업체가 효율성을 극대화하고, 비용을 절감하며, 제품 품질을 향상 시키는데 연구 및 개발 투자를 적극적으로 하고 있습니다.</p>
                  <a onClick={goToTech} className="btn-red">VIEW MORE</a>
              </div>
          </div>
          <div className="area-cont">
              <div className="tech-img-wrap">
                  <div className="tech-box">
                      <div className="tech-video tech-1">
                          <h3>신기술 연구 및 탐색</h3>
                          <p>새로운 프로그래밍 언어, 프레임워크, 라이브러리, 알고리즘 등을 연구하고 이를 기반으로 혁신적인 소프트웨어 솔루션을 개발을 하고 있습니다.</p>
                          <video className="video-background" poster="/img/main_bg.jpg" autoPlay loop muted playsInline>
                              <source src={tech1} type="video/mp4"/>
                          </video>
                      </div>
                  </div>

                  <div className="tech-box">
                      <div className="tech-video tech-2">
                          <h3>제품 개발 및 개선</h3>
                          <p>기존 제품의 기능 개선, 사용자 인터페이스(UI) 개선, 사용자 경험(UX) 최적화, 성능 향상 등을 통해 사용자 피드백을 적극적으로 수집하고 분석하여 제품 개발 방향을 결정합니다.</p>
                          <video className="video-background" poster="/img/main_bg.jpg" autoPlay loop muted playsInline>
                              <source src={tech2} type="video/mp4"/>
                          </video>
                      </div>
                  </div>

                  <div className="tech-box">
                      <div className="tech-video tech-3">
                          <h3>프로토타입 개발 및 테스팅</h3>
                          <p>새로운 아이디어나 기술을 검증하기 위해 프로토타입을 개발하고 이를 통해 실제 사용 환경에서의 성능과 사용자 반응을 테스트합니다.</p>
                          <video className="video-background" poster="/img/main_bg.jpg" autoPlay loop muted playsInline>
                              <source src={tech3} type="video/mp4"/>
                          </video>
                      </div>
                  </div>

                  <div className="tech-box">
                      <div className="tech-video tech-4">
                          <h3>시장 및 기술 트렌드 분석</h3>
                          <p>지속적인 시장 조사와 기술 트렌드 분석을 통해 새로운 기술 발전 방향과 시장의 수요를 파악하여 연구 개발 활동의 방향성을 결정하고, 장기적인 기술 로드맵을 수립합니다.</p>
                          <video className="video-background" poster="/img/main_bg.jpg" autoPlay loop muted playsInline>
                              <source  src={tech4} type="video/mp4"/>
                          </video>
                      </div>
                  </div>
              </div>
          </div>
      </div> 
    </section>
    </div>
   
  );
}

export default MainPage;
